import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiChatHelperService } from '@fi-shared/fi-chat/fi-chat-helper.service';
import { IChatConversation } from '@fi-shared/fi-chat/fi-chat';
import { ILightWeightUser } from '@fi-shared/models';

@Component({
    selector: 'fi-chat-conversation-forward-list',
    template: `
        <fi-chat-conversation-list-container
            class="shown"
            [forwardMessageMode]="true"
            (openExistingConversation)="handleOpenExistingConversation($event)"
            (openNewConversation)="handleOpenNewConversation($event)"
            (closeConversationList)="closeConversationForwardList()"
        />
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-chat-conversation-forward-list' },
    standalone: false,
})
export class FiChatConversationForwardListComponent {
    constructor(private fiChatHelperService: FiChatHelperService) {}

    protected handleOpenExistingConversation(conversation: IChatConversation): void {
        this.fiChatHelperService.openForwardMessageConversation(conversation);
    }

    protected handleOpenNewConversation(targetUser: ILightWeightUser): void {
        this.fiChatHelperService.openForwardMessageNewConversation(targetUser);
    }

    protected closeConversationForwardList(): void {
        this.fiChatHelperService.closeForwardMessageConversationList();
    }
}
